import React from 'react'

import '../../styles/SwiftBankingStyles/swiftbanking.css'
import KronnBank from './../../resources/SwiftBankingResources/kronn-bank.svg'
import CraneOne from './CraneOne.js'
import CraneTwo from './CraneTwo.js'
import CraneThree from './CraneThree.js'
import CraneFour from './CraneFour.js'

import bank from '../../resources/SwiftBankingResources/kronn-bank.svg';

export default class SwiftBanking extends React.Component{
    render(){
        return(
            <section className="sb__container" id="swift-banking-anchor" style={{marginBottom: 150}}>

                <div className='sb__bank-illustration-container'>
                    <img src={bank} className='sb__bank-illustration' />
                </div>


                <div className="sb__c1-pos">
                    <CraneOne />
                </div>
                <div className="sb__c2-pos">
                    <CraneTwo />
                </div>
                <div className="sb__c3-pos">
                    <CraneThree/>
                </div>
                <div className="sb__c4-pos">
                    <CraneFour/>
                </div>

            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SwiftBanking/SwiftBanking.js